import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import Fetching from "@/components/Fetching/Fetching";
import classes from "./edit_text.module.scss";

const EditText = ({ handleChange, currentValue, currentLabel, needPermission = false, placeholder = "", maxLength, minLength, required = false }) => {
	const { user } = useSelector((state) => state.auth);
	const tools = user ? user.tools : [];
	const profiles = user ? user.profiles : [];

	useEffect(() => {
		if (currentValue) {
			setLocalValue(currentValue);
		}
	}, [currentValue]);

	const [localValue, setLocalValue] = useState("");
	const [edit, setEdit] = useState(false);
	const [fetching, setFetching] = useState(false);

	const handleLocalChange = async () => {
		setEdit(false);
		setFetching(true);

		await handleChange(localValue);

		setFetching(false);
	};

	let hasPermission = true;
	if (needPermission && !(tools.find((tool) => tool.id === 19) && profiles.find((profile) => profile.id === 4))) {
		hasPermission = false;
	}

	if (fetching) {
		return <Fetching topMargin={"0em"} />;
	}

	if (edit) {
		return (
			<div style={{ width: "100%" }}>
				<CustomInputText
					name="edit_text"
					value={localValue}
					onChange={setLocalValue}
					placeholder={placeholder}
					maxLength={maxLength}
					minLength={minLength}
					required={required}
					autoFocus
				/>

				<div className={classes.editable_button}>
					<button className={classes.button_cancel} onClick={() => setEdit(false)}>
						Cancelar
					</button>
					<button className={classes.button_confirm} onClick={handleLocalChange}>
						Guardar
					</button>
				</div>
			</div>
		);
	}

	return (
		<span className={classes.textSpan} onClick={() => hasPermission && setEdit(true)}>
			{currentLabel}
		</span>
	);
};

export default EditText;
